import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil , faMinus ,faSearch ,faTimes, faArrowLeft, faImage  } from "@fortawesome/free-solid-svg-icons";
import ArrowLeft from './images/ArrowLeft.png';


// Professional Modal Component
const StatusModal = ({ visible, type, title, message, onClose }) => {
  const [fadeAnim, setFadeAnim] = useState(0);
  const [scaleAnim, setScaleAnim] = useState(0.8);

  useEffect(() => {
    if (visible) {
      setFadeAnim(1);
      setScaleAnim(1);
    } else {
      setFadeAnim(0);
      setScaleAnim(0.8);
    }
  }, [visible]);

  const getModalConfig = () => {
    switch (type) {
      case 'success':
        return {
          icon: '✓',
          iconColor: '#10B981',
          bgColor: 'bg-green-50',
          borderColor: 'border-green-200',
          buttonColor: 'bg-green-600',
        };
      case 'error':
        return {
          icon: '✗',
          iconColor: '#EF4444',
          bgColor: 'bg-red-50',
          borderColor: 'border-red-200',
          buttonColor: 'bg-red-600',
        };
      default:
        return {
          icon: '✓',
          iconColor: '#6B7280',
          bgColor: 'bg-gray-50',
          borderColor: 'border-gray-200',
          buttonColor: 'bg-gray-600',
        };
    }
  };

  const config = getModalConfig();

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center px-6 bg-black bg-opacity-50 z-[9999]"
      style={{ opacity: fadeAnim, transition: 'opacity 0.3s' }}
    >
      <div
        className={`bg-white rounded-2xl p-6 w-full max-w-sm shadow-2xl border ${config.bgColor} ${config.borderColor}`}
        style={{ transform: `scale(${scaleAnim})`, transition: 'transform 0.3s' }}
      >
        {/* Close Button */}
        <button
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center"
          onClick={onClose}
        >
          <span className="text-lg text-gray-400">×</span>
        </button>

        {/* Icon */}
        <div className="flex items-center justify-center mb-4">
          <div
            className={`w-16 h-16 rounded-full flex items-center justify-center`}
            style={{ backgroundColor: config.iconColor + '20' }}
          >
            <span className="text-3xl" style={{ color: config.iconColor }}>
              {config.icon}
            </span>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold text-gray-900 text-center mb-2">
          {title}
        </h2>

        {/* Message */}
        <p className="text-gray-600 text-center mb-6 leading-6">
          {message}
        </p>

        {/* Action Button */}
        <button
          className={`w-full py-3 px-6 rounded-lg ${config.buttonColor} text-white font-semibold`}
          onClick={onClose}
        >
          Got it
        </button>
      </div>
    </div>
  );
};

// Confirmation Modal Component
const ConfirmationModal = ({ visible, title, message, onConfirm, onCancel, isLoading }) => {
  const [fadeAnim, setFadeAnim] = useState(0);
  const [scaleAnim, setScaleAnim] = useState(0.8);

  useEffect(() => {
    if (visible) {
      setFadeAnim(1);
      setScaleAnim(1);
    }
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center px-6 bg-black bg-opacity-50 z-[9999]"
      style={{ opacity: fadeAnim, transition: 'opacity 0.3s' }}
    >
      <div
        className="bg-white rounded-2xl p-6 w-full max-w-sm shadow-2xl"
        style={{ transform: `scale(${scaleAnim})`, transition: 'transform 0.3s' }}
      >
        {/* Icon */}
        <div className="flex items-center justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center">
            <span className="text-3xl text-orange-600">⚠</span>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold text-gray-900 text-center mb-2">
          {title}
        </h2>

        {/* Message */}
        <p className="text-gray-600 text-center mb-6 leading-6">
          {message}
        </p>

        {/* Action Buttons */}
        <div className="flex gap-3">
          <button
            className="flex-1 bg-gray-200 py-3 px-4 rounded-lg text-gray-800 font-semibold"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="flex-1 bg-red-600 py-3 px-4 rounded-lg text-white font-semibold flex items-center justify-center"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            ) : (
              'Confirm'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

// Tab Component
const TabButton = ({ title, count, isActive, onPress }) => (
  <button
    className={`flex-1 py-2 items-center justify-center border-b-2 ${
      isActive ? 'border-red-500' : 'border-transparent'
    }`}
    onClick={onPress}
  >
    <span className={`text-base font-semibold ${
      isActive ? 'text-red-500' : 'text-gray-500'
    }`}>
      {title} {count > 0 && `(${count})`}
    </span>
  </button>
);
const ItemsListScreen = () => {
  const navigate = useNavigate();
    const location = useLocation();
 const isValidCategoryId = (id) => /^[0-9a-fA-F]{24}$/.test(id);
  // Extract vendorData and categoryId from URL params or location.state synchronously
  const extractInitialData = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const responseDataParam = searchParams.get("responseData");
    const categoryIdParam = searchParams.get("categoryId");
    if (responseDataParam) {
      try {
        const parsedData = JSON.parse(decodeURIComponent(responseDataParam));
        const vendorDataObj = {
          id: parsedData._id,
          token: parsedData.token,
          mobile_number: parsedData.mobile_number,
          email: parsedData.email,
          company_name: parsedData.company_name,
          name: parsedData.name,
          OrganizationId: parsedData.organizationId,
          vendor_status: parsedData.vendor_status,
        };
        // Save vendor data to storage
        localStorage.setItem("vendorData", JSON.stringify(vendorDataObj));
        localStorage.setItem("userId", vendorDataObj.id);
        sessionStorage.setItem('vendorId', vendorDataObj.id);
        sessionStorage.setItem('token', vendorDataObj.token);
        // Validate categoryIdParam before returning
        if (categoryIdParam && isValidCategoryId(categoryIdParam)) {
          return categoryIdParam.trim();
        }
      } catch (error) {
        console.error("Error parsing responseData param:", error);
}
    }
    // If no responseData param, try location.state
    if (location?.state?.vendorData) {
      const vendorDataObj = location.state.vendorData;
      // Save vendor data to storage
      localStorage.setItem("vendorData", JSON.stringify(vendorDataObj));
      localStorage.setItem("userId", vendorDataObj.id);
      sessionStorage.setItem('vendorId', vendorDataObj.id);
      sessionStorage.setItem('token', vendorDataObj.token);
      if (location.state.categoryId && isValidCategoryId(location.state.categoryId)) {
        return location.state.categoryId.trim();
      }
    }
    // Finally, fallback to URL param categoryId if valid
    if (categoryIdParam && isValidCategoryId(categoryIdParam)) {
      return categoryIdParam.trim();
    }
    // No valid categoryId found
    return null;
  };
  // Synchronously get categoryId and set vendor data if present
  const categoryId = extractInitialData();
  const categoryName = location.state?.categoryName || "";
  console.log("Extracted categoryId:", categoryId);
  console.log("Extracted categoryName:", categoryName);

  const [sellingProducts, setSellingProducts] = useState([]);
  const [notSellingProducts, setNotSellingProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [deletingProductId, setDeletingProductId] = useState(null);
  const [isAssigning, setIsAssigning] = useState(false);
  const [vendorData, setVendorData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [newPrice, setNewPrice] = useState("");
  const [refreshing, setRefreshing] = useState(false);
  const [activeTab, setActiveTab] = useState('selling'); 
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [isUpdatingPrice, setIsUpdatingPrice] = useState(false);
   const [loader, setLoader] = useState(true);
  const [loadingProgress, setLoadingProgress] = useState(0);
  

  // Modal states
  const [statusModal, setStatusModal] = useState({
    visible: false,
    type: 'success',
    title: '',
    message: '',
  });
  const [confirmModal, setConfirmModal] = useState({
    visible: false,
    title: '',
    message: '',
    onConfirm: null,
    productName: '',
  });

  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const ImgUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;

  // Filter products based on search query
  const filteredSellingProducts = sellingProducts.filter(product =>
    product.product_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    product.SKU_Code?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredNotSellingProducts = notSellingProducts.filter(product =>
    product.product_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    product.SKU_Code?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Show status modal
  const showStatusModal = (type, title, message) => {
    setStatusModal({
      visible: true,
      type,
      title,
      message,
    });
  };

  // Hide status modal
  const hideStatusModal = () => {
    setStatusModal(prev => ({ ...prev, visible: false }));
  };

  // Show confirmation modal
  const showConfirmModal = (title, message, onConfirm) => {
    setConfirmModal({
      visible: true,
      title,
      message,
      onConfirm,
    });
  };

  // Hide confirmation modal
  const hideConfirmModal = () => {
    setConfirmModal(prev => ({ ...prev, visible: false }));
  };

  // Get vendor data on component mount
  useEffect(() => {
    const getVendorData = async () => {
      try {
        const vendorDataString = localStorage.getItem('vendorData');
        if (vendorDataString) {
          setVendorData(JSON.parse(vendorDataString));
        }
      } catch (error) {
        console.error('Error getting vendor data:', error);
      }
    };
    getVendorData();
  }, []);

  useEffect(() => {
          if (loader) {
              const progressInterval = setInterval(() => {
                  setLoadingProgress(prevProgress => {
                      if (prevProgress >= 90) {
                          clearInterval(progressInterval);
                          return 90;
                      }
                      return prevProgress + 10;
                  });
              }, 500);
  
              return () => clearInterval(progressInterval);
          }
      }, [loader]);

 useEffect(() => {
  const fetchAll = async () => {
    setIsLoading(true);
    await Promise.all([FetchSellingProducts(), FetchNotSellingProducts()]);
    setIsLoading(false);
    
    setLoadingProgress(100);
    setTimeout(() => {
      setLoader(false);
    }, 500);
  };
  fetchAll();

}, []);
  const FetchSellingProducts = async () => {
    try {
      const vendorDataString = localStorage.getItem('vendorData');
      if (!vendorDataString) throw new Error('Vendor data not found.');
      const vendorData = JSON.parse(vendorDataString);
      if (!vendorData?.id) throw new Error('Invalid vendor data.');

      const response = await fetch(
        `${fetchUrl}product/get-quick-buy-products-by-vendor-category?vendor_id=${vendorData.id}&product_category_id=${categoryId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': vendorData.token,
          },
        }
      );
      const data = await response.json();
      console.log('Selling Products Data:', data);
      setSellingProducts(data?.data?.products || []);
    } catch (error) {
      console.error('Error fetching selling products:', error);
      setSellingProducts([]);
    }
  };

  const FetchNotSellingProducts = async () => {
    try {
      const vendorDataString = localStorage.getItem('vendorData');
      if (!vendorDataString) throw new Error('Vendor data not found.');
      const vendorData = JSON.parse(vendorDataString);
      if (!vendorData?.id) throw new Error('Invalid vendor data.');

      const response = await fetch(
        `${fetchUrl}product/get-products-data-by-product-category?product_category_id=${categoryId}&vendor_id=${vendorData.id}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': vendorData.token,
          },
        }
      );
      const data = await response.json();
      console.log('Not Selling Products Data:', data);
      setNotSellingProducts(data?.data || []);
    } catch (error) {
      console.error('Error fetching not selling products:', error);
      setNotSellingProducts([]);
    }
  };

  const onRefresh = async () => {
    setRefreshing(true);
    setIsLoading(true);
    try {
      await FetchSellingProducts(); 
      await FetchNotSellingProducts(); 
    } catch (err) {
      console.error("Refresh error:", err);
    } finally {
      setRefreshing(false);
      setIsLoading(false);
    }
  };

  // Handle product selection with data structure
  const toggleProductSelection = (productId) => {
    setSelectedProducts(prev => {
      const newSelected = { ...prev };
      
      if (newSelected[productId]) {
        // Deselect
        delete newSelected[productId];
      } else {
        // Select with default values
        const product = notSellingProducts.find(p => p._id === productId);
        newSelected[productId] = {
          selected: true,
          supplier_price: product?.selling_price || '',
          SKU_Code: product?.SKU_Code || '',
          moqs: []
        };
      }
      
      return newSelected;
    });
  };

  // Clear all selections
  const clearSelections = () => {
    setSelectedProducts({});
  };

  // Transform assignment for backend
  const transformAssignmentForBackend = (assignment) => {
    const transformedItems = assignment.assigned_products.map(product => ({
      id: product.product_id,
      price: product.selling_price,
      SKU_Code: product.SKU_Code,
      Moqs: product.moqs || []
    }));

    return {
      vendor_id: assignment.vendor_id,
      pc_items: [{
        product_category_id: assignment.product_category_id,
        items: transformedItems
      }]
    };
  };

  // API call to assign items
  const assignItemsToSupplier = async (assignmentData) => {
    try {
      const response = await fetch(`${fetchUrl}product/assign-vendor-to-products`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': vendorData.token,
        },
        body: JSON.stringify(assignmentData)
      });
      
      const result = await response.json();
      return { success: response.ok, data: result, error: result.message };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  // Handle assignment
  const handleAssign = async () => {
    setIsAssigning(true);
    
    try {
      const assignedProducts = Object.entries(selectedProducts)
        .filter(([_, data]) => data.selected)
        .map(([productId, data]) => {
          const product = notSellingProducts.find(p => p._id === productId);
          return {
            product_id: productId,
            product_name: product.product_name,
            selling_price: data.supplier_price,
            SKU_Code: data.SKU_Code,
            original_price: product.selling_price,
            moqs: data.moqs || [],
            assigned_date: new Date().toISOString().split('T')[0],
            is_active: true
          };
        });

      const assignment = {
        _id: `assign_${Date.now()}`,
        vendor_id: vendorData.id,
        product_category_id: categoryId,
        assigned_products: assignedProducts
      };
      
      await handleAssignmentComplete(assignment);
      
    } catch (error) {
      console.error('Error in handleAssign:', error);
      showStatusModal('error', 'Assignment Failed', 'Failed to prepare assignment data');
    } finally {
      setIsAssigning(false);
    }
  };

  // Handle assignment completion
  const handleAssignmentComplete = async (newAssignment) => {
    try {
      const transformedAssignment = transformAssignmentForBackend(newAssignment);
      
      const result = await assignItemsToSupplier(transformedAssignment);
      
      if (result.success) {
        showStatusModal('success', 'Assignment Successful', 'Products assigned successfully!');
        
        setIsLoading(true);
        await Promise.all([FetchSellingProducts(), FetchNotSellingProducts()]);
        setIsLoading(false);
        
        clearSelections();
        
      } else {
        showStatusModal('error', 'Assignment Failed', result.error || 'Failed to assign products');
      }
    } catch (error) {
      console.error('Error in handleAssignmentComplete:', error);
      showStatusModal('error', 'Assignment Failed', 'An unexpected error occurred while assigning products');
    }
  };

  // Delete product function
  const deleteProduct = async (productId) => {
    setDeletingProductId(productId);
    try {
      const vendorDataString = localStorage.getItem('vendorData');
      if (!vendorDataString) throw new Error('Vendor data not found.');
      const vendorData = JSON.parse(vendorDataString);
      if (!vendorData?.id || !vendorData?.token) throw new Error('Invalid vendor data.');

      const response = await fetch(
        `${fetchUrl}product/delete-supplier-assigned-product?product_id=${productId}&vendor_id=${vendorData.id}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'x-token': vendorData.token,
          },
        }
      );

      const result = await response.json();

      if (response.ok) {
        showStatusModal('success', 'Product Removed', 'Product removed successfully from your selling list!');
        
        setIsLoading(true);
        await Promise.all([FetchSellingProducts(), FetchNotSellingProducts()]);
        setIsLoading(false);
      } else {
        throw new Error(result.message || 'Failed to delete product');
      }
      
    } catch (error) {
      console.error('Error deleting product:', error);
      showStatusModal('error', 'Deletion Failed', 'Failed to remove product. Please try again.');
    } finally {
      setDeletingProductId(null);
    }
  };

  const handleDeleteProduct = (productId, productName) => {
    showConfirmModal(
      'Remove Product',
      `Are you sure you want to remove "${productName}" from selling products?`,
      () => {
        hideConfirmModal();
        deleteProduct(productId);
      }
    );
  };

  // Selling Product Card - 2 column layout
const renderSellingProductCard = (item) => (
  <div
    key={item._id}
    className="relative bg-white rounded-lg p-3 mb-4 shadow-sm border border-gray-100 w-[48%]"
  >
    {/* Red Minus Button inside image top-right */}
   <button
    className="absolute top-1 right-1  w-6 h-6 border border-red-500 rounded-full flex items-center justify-center shadow-md z-20"
    onClick={() => handleDeleteProduct(item._id, item.product_name)}
    disabled={deletingProductId === item._id}
  >
    {deletingProductId === item._id ? (
      <div className="w-3 h-3 border-2 border-red-500 border-t-transparent rounded-full animate-spin"></div>
    ) : (
      <FontAwesomeIcon icon={faMinus} className="text-red-500 text-xs" />
    )}
  </button>

    {/* Product Image */}
    <div className="relative mb-2 w-full h-20 flex items-center justify-center bg-gray-50 rounded-md overflow-hidden">

  {item.product_image ? (
    <img
      src={`${ImgUrl}${item.product_image}`}
      alt={item.product_name}
      className="w-full h-full object-contain"
      onError={(e) => {
        e.target.src = "";   // hides broken image
      }}
    />
  ) : (
    <FontAwesomeIcon icon={faImage} className="text-gray-400 text-3xl" />
  )}

</div>


    {/* Product Name */}
    <p
      className="text-xs font-regular text-gray-800 mb-1"
      style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
      }}
    >
      {item.product_name}
    </p>

    {/* Price + Pencil Edit */}
    <div className="flex items-center mt-1">
    <span className="text-sm font-bold text-gray-900">
  ₹{
    Number(
      item?.vendor_details?.vendor_price ??
      item?.selling_price ??
      item?.price ??
      0
    ).toLocaleString("en-IN")
  }
</span>

      {/* FA Pencil Button (updated alignment + rounded ) */}
      <button
        className="ml-2 w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center"
        onClick={() => openPriceEditor(item)}
      >
  <FontAwesomeIcon icon={faPencil} className="text-gray-600 text-[9px]" />
      </button>
    </div>
  </div>
);


  // Not Selling Product Card - 3 column layout (as per design)
const renderNotSellingProductCard = (item) => {
  const isSelected = selectedProducts[item._id]?.selected;
  
  return (
    <div
      key={item._id}
      className={`bg-white rounded-lg p-2 mb-3 shadow-sm border ${
        isSelected ? 'border-green-500 bg-green-50' : 'border-gray-100'
      } w-[48%]`} // Changed to 2 columns using w-[48%] instead of calc for 3
    >
      {/* Product Image and Selection Button */}
    <div className="relative mb-2">
  {item.product_image ? (
    <img
      src={`${ImgUrl}${item.product_image}`}
      alt={item.product_name}
      className="w-full h-20 rounded-md bg-gray-100 object-contain"
      onError={(e) => (e.target.style.display = "none")}
    />
  ) : (
    <div className="w-full h-20 bg-gray-100 rounded-md flex items-center justify-center">
      <FontAwesomeIcon icon={faImage} className="text-gray-400 text-3xl" />
    </div>
  )}
  
        <button
          className={`absolute top-1 right-1 rounded-full w-5 h-5 flex items-center justify-center ${
            isSelected ? 'bg-green-500' : 'bg-gray-400'
          }`}
          onClick={() => toggleProductSelection(item._id)}
        >
          <span className="text-white text-xs">{isSelected ? '✓' : '+'}</span>
        </button>
      </div>

      {/* Product Name */}
      <p
        className="text-xs font-medium text-gray-800 mb-1"
        style={{ overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}
      >
        {item.product_name}
      </p>

      {/* Price */}
     <span className="text-sm font-bold text-gray-900">
  ₹{Number(item?.selling_price ?? item?.price ?? 0).toLocaleString("en-IN")}
</span>
    </div>
  );
};

  // Floating Action Bar for Not Selling tab
  const FloatingActionBar = ({ selectedCount, onAssign, onClear, isAssigning }) => {
    const [slideAnim, setSlideAnim] = useState(100);

    useEffect(() => {
      if (selectedCount > 0) {
        setSlideAnim(0);
      } else {
        setSlideAnim(100);
      }
    }, [selectedCount]);

    if (selectedCount === 0) return null;

    return (
      <div
        className="fixed bottom-4 left-4 right-4 bg-white rounded-xl px-4 py-3 flex items-center justify-between shadow-lg border border-gray-200 z-50"
        style={{ transform: `translateY(${slideAnim}px)`, transition: 'transform 0.2s' }}
      >
        <div className="flex-1">
          <span className="text-sm font-semibold text-gray-900">
            {selectedCount} Product{selectedCount > 1 ? 's' : ''} Selected
          </span>
        </div>

        <div className="flex gap-2">
          <button
            className="bg-gray-500 py-2 px-4 rounded-lg text-white font-medium"
            onClick={onClear}
            disabled={isAssigning}
          >
            Clear
          </button>
          
          <button
            className="bg-red-600 py-2 px-4 rounded-lg text-white font-semibold flex items-center"
            onClick={onAssign}
            disabled={isAssigning}
          >
            {isAssigning ? (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            ) : (
              `Assign (${selectedCount})`
            )}
          </button>
        </div>
      </div>
    );
  };

  const openPriceEditor = (item) => {
    setSelectedItem(item);
    setNewPrice(String(item.vendor_details?.vendor_price || item.selling_price || "0"));
    setShowModal(true);
  };

  const confirmPriceUpdate = () => {
    // Show confirmation modal before updating price
    showConfirmModal(
      'Update Price',
      `Are you sure you want to update the price to ₹${newPrice}?`,
      () => {
        hideConfirmModal();
        if (selectedItem) {
          handleUpdatePrice(selectedItem._id, newPrice);
        }
      }
    );
  };

  const handleUpdatePrice = async (ItemId, newPrice) => {
    setIsUpdatingPrice(true);
    try {
      const token = sessionStorage.getItem("token");
      if (!token) throw new Error("No authentication token found");

      const vendorId = vendorData.id;
      if (!vendorId) throw new Error("Vendor ID not found");
      if (!ItemId) throw new Error("Product ID not found");

      const data = {
        vendor_price: newPrice,
        SKU_Code: null,
        moqs: [],
      };

      const response = await fetch(
        `${fetchUrl}product/update-supplier-product-data?product_id=${ItemId}&vendor_id=${vendorId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
          body: JSON.stringify(data),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || `HTTP error! status: ${response.status}`);
      }

      if (result.success) {
        console.log("Product updated successfully:", result);
        
        // Show success modal instead of Alert
        showStatusModal('success', 'Price Updated', 'Product price has been updated successfully!');
        
        // Refresh data
        await FetchSellingProducts();
        await FetchNotSellingProducts();
        
        // Close the price editor modal
        setShowModal(false);
      } else {
        throw new Error(result.message || "Failed to update product");
      }
    } catch (error) {
      console.error("Error saving product edit:", error);
      // Show error modal instead of Alert
      showStatusModal('error', 'Update Failed', error.message || 'Failed to update product price. Please try again.');
    } finally {
      setIsUpdatingPrice(false);
    }
  };

  // Toggle search bar visibility
  const toggleSearchBar = () => {
    setShowSearchBar(!showSearchBar);
    if (showSearchBar) {
      setSearchQuery(''); // Clear search when closing
    }
  };

   const LoadingSpinner = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/70 backdrop-blur-sm">
    <div className="relative">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div className="animate-spin w-16 h-16 border-4 border-[#F43042] border-t-transparent rounded-full animate-spin"></div>
      </div>
      <div className="mt-24 text-center">
        <p className="text-[#524D4D] font-medium animate-pulse">
           Loading Products...
        </p>
      </div>
    </div>
  </div>
);

const ProgressLoader = ({ progress }) => (
  <div className="fixed top-0 left-0 right-0 z-[60]">
    <div 
      className="h-1 bg-[#F43042]" 
      style={{ 
        width: `${progress}%`, 
        transition: 'width 0.5s ease-in-out' 
      }}
    ></div>
  </div>
);

  const selectedCount = Object.keys(selectedProducts).length;

  return (
    <div className="flex-1 bg-white">

        {loader && (
                <>
                    <ProgressLoader progress={loadingProgress} />
                    <LoadingSpinner />
                </>
            )}
      {/* Status Modal */}
      <StatusModal
        visible={statusModal.visible}
        type={statusModal.type}
        title={statusModal.title}
        message={statusModal.message}
        onClose={hideStatusModal}
      />

      {/* Confirmation Modal */}
      <ConfirmationModal
        visible={confirmModal.visible}
        title={confirmModal.title}
        message={confirmModal.message}
        onConfirm={confirmModal.onConfirm}
        onCancel={hideConfirmModal}
        isLoading={isUpdatingPrice}
      />

      {/* Header */}
      <div className="bg-white">
        {/* Main Header Row */}
    <div className="sticky top-0 bg-white z-50 h-14 px-1 shadow-md flex items-center justify-between">

  {/* Left Section: Arrow + Title */}
  <div className="flex flex-col justify-center">
    <div className="flex items-center">
      <button 
        onClick={() => navigate(-1)} 
        className="active:scale-90 transition"
      >
        <img
          src={ArrowLeft}
          alt="Back"
          className="h-8 w-12"
        />
      </button>

      <span className="text-lg font-semibold text-gray-900 leading-none">
        Products
      </span>
    </div>

    {/* Category Name on next line */}
    {categoryName && (
      <span className="text-xs text-gray-600 ml-12 -mt-1">
        {categoryName}
      </span>
    )}
  </div>

  {/* Right Section: Search Icon */}
  <button
    onClick={toggleSearchBar}
    className="p-2 active:scale-95 transition"
  >
    <FontAwesomeIcon
      icon={faSearch}
      className={`text-xl ${showSearchBar ? "text-red-500" : "text-gray-700"}`}
    />
  </button>

</div>


        {/* Search Bar - Conditionally Rendered */}
       {showSearchBar && (
  <div className="flex items-center bg-gray-100 rounded-lg px-4 mx-3 py-2 mt-6">
    
    {/* FA Search Icon */}
    <FontAwesomeIcon 
      icon={faSearch} 
      className="text-gray-500 text-sm" 
    />

    <input
      type="text"
      placeholder="Search by Product name...!"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      className="flex-1 ml-2 bg-transparent text-gray-700 outline-none"
      autoFocus={true}
    />

    {/* Clear (X) Icon using FontAwesome */}
    {searchQuery.length > 0 && (
      <button
        onClick={() => setSearchQuery('')}
        className="p-1"
      >
        <FontAwesomeIcon 
          icon={faTimes} 
          className="text-gray-500 text-base" 
        />
      </button>
    )}
  </div>
)}

        
      </div>

      {/* Tabs */}
      <div className="flex bg-white mt-4">
        <TabButton
          title="Selling"
          count={filteredSellingProducts.length}
          isActive={activeTab === 'selling'}
          onPress={() => setActiveTab('selling')}
        />
        <TabButton
          title="Not Selling"
          count={filteredNotSellingProducts.length}
          isActive={activeTab === 'notSelling'}
          onPress={() => setActiveTab('notSelling')}
        />
      </div>

      {/* Content */}
      <div className="p-3 overflow-y-auto" style={{ height: 'calc(100vh - 120px)' }}>
        {/* Selling Products Tab Content - 2 column layout */}
        {activeTab === 'selling' && (
          <div className="flex flex-wrap justify-between">
            {filteredSellingProducts.map((item) => (
              renderSellingProductCard(item)
            ))}
          </div>
        )}

        {/* Not Selling Products Tab Content - 3 column layout */}
        {activeTab === 'notSelling' && (
          <div className="flex flex-wrap justify-between">
            {filteredNotSellingProducts.map((item) => (
              renderNotSellingProductCard(item)
            ))}
          </div>
        )}

        {/* Empty State */}
        {(activeTab === 'selling' && filteredSellingProducts.length === 0) ||
        (activeTab === 'notSelling' && filteredNotSellingProducts.length === 0) ? (
          <div className="flex-1 flex justify-center items-center py-20">
            <span className="text-gray-500 text-lg">
              {searchQuery ? 'No products found for your search' : 'No products found'}
            </span>
          </div>
        ) : null}
      </div>

      {/* Edit Price Modal */}
   {showModal && (
  <div className="fixed inset-0 flex items-end bg-black bg-opacity-50 z-50">
    <div className="bg-white w-full rounded-t-xl overflow-y-auto max-h-[90vh]">
      {/* Header with Drag Indicator */}
      <div className="flex justify-center py-3">
        <div className="w-12 h-1 bg-gray-300 rounded-full"></div>
      </div>

      {/* Close Button */}
    <button
  className="absolute  right-4 w-8 h-8 flex items-center justify-center"
  onClick={() => setShowModal(false)}
>
  <svg
    className="w-6 h-6 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
</button>


      <div className="px-6 pb-8 pt-2">
        {/* Product Info Section */}
        <div className="flex flex-col items-center mb-6">
          {selectedItem?.product_image && (
            <img
              src={`${ImgUrl}${selectedItem.product_image}`}
              alt={selectedItem.product_name}
              className="w-20 h-20 rounded-xl bg-gray-100 mb-3 object-contain"
            />
          )}
          <h2 className="text-lg font-bold text-gray-900 text-center mb-1">
            Update Price
          </h2>
          <span className="text-sm text-gray-600 text-center">
            {selectedItem?.product_name}
          </span>
        </div>

        {/* Price Input Section */}
        <div className="mb-6">
          <label className="text-sm font-medium text-gray-700 mb-3 block">
            Selling Price
          </label>
          
          {/* Price Input with Currency Symbol */}
          <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-4 py-3">
            <span className="text-gray-500 text-lg font-medium mr-2">₹</span>
            <input
              type="number"
              value={newPrice}
              onChange={(e) => setNewPrice(e.target.value)}
              className="flex-1 bg-transparent text-gray-900 text-lg font-medium outline-none"
              // placeholder="0.00"
              autoFocus={true}
            />
          </div>
          
          {/* Helper Text */}
          <span className="text-xs text-gray-500 mt-2 block">
            Enter the price you want to sell this product for
          </span>
        </div>

        {/* Original Price Comparison (if available) */}
        {selectedItem?.selling_price && (
          <div className="bg-blue-50 rounded-xl p-3 mb-6">
            <span className="text-xs text-blue-800 font-medium mb-1 block">
              Original Price
            </span>
            <span className="text-blue-900 font-semibold">
              ₹{selectedItem.selling_price}
            </span>
          </div>
        )}

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            className={`w-full rounded-xl py-4 flex items-center justify-center shadow-sm ${
              newPrice && parseFloat(newPrice) > 0 
                ? 'bg-red-500 shadow-lg text-white' 
                : 'bg-gray-300 text-gray-500'
            }`}
            onClick={confirmPriceUpdate}
            disabled={!newPrice || parseFloat(newPrice) <= 0 || isUpdatingPrice}
          >
            {isUpdatingPrice ? (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            ) : (
              <span className="font-bold text-base">Update Price</span>
            )}
          </button>

          <button
            className="w-full border border-gray-300 rounded-xl py-4 flex items-center justify-center"
            onClick={() => setShowModal(false)}
            disabled={isUpdatingPrice}
          >
            <span className="text-gray-700 font-medium text-base">Cancel</span>
          </button>
        </div>
      </div>
    </div>
  </div>
)}


      {/* Floating Action Bar - Only show on Not Selling tab when items are selected */}
      {activeTab === 'notSelling' && (
        <FloatingActionBar
          selectedCount={selectedCount}
          onAssign={handleAssign}
          onClear={clearSelections}
          isAssigning={isAssigning}
        />
      )}
    </div>
  );
};

export default ItemsListScreen;
